module.exports = __webpack_public_path__ + "img/resource-tech-image-21.e2391612.jpg";